import tmhRequest from '@/config/tmhRequest'

export default {

    searchProjectMappingCount: function (data) {
        return tmhRequest({
            url: '/project/tmh/projectmapping/searchprojectmappingcount',
            method: 'post',
            data: data,
        })
    },

    searchProjectMappingByPage: function (data) {
        return tmhRequest({
            url: '/project/tmh/projectmapping/searchprojectmappingbypage',
            method: 'post',
            data: data,
        })
    },

    downloadProjectMapping: function (data) {
        return tmhRequest({
            url: '/project/tmh/projectmapping/downloadprojectmapping',
            method: 'post',
            params: data,
        })
    },

    mapProjectMapping: function (data) {
        return tmhRequest({
            url: '/project/tmh/projectmapping/mapprojectmapping',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/projectmapping.js